import axios from 'axios';
import { getApiBase } from './origin';

const BASE = getApiBase();

export const staffApi = axios.create({ baseURL: BASE });
staffApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('staff_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
staffApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('staff_token');
      localStorage.removeItem('staff_user');
      window.location.href = '/staff/login';
    }
    return Promise.reject(err);
  }
);

export const adminApi = axios.create({ baseURL: BASE });
adminApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('admin_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const venueId = localStorage.getItem('active_venue_id');
  if (venueId) cfg.headers['X-Venue-Id'] = venueId;
  return cfg;
});
adminApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default staffApi;
